module.exports = __webpack_public_path__ + "static/media/crvBUSD-logo.5008aa36.png";